import {combineReducers } from 'redux';
import auth from './authentication';
export default combineReducers({
    auth
});